export const API = process.env.REACT_APP_BACKEND_URL || "";

export const SITE = {
  name: "Exoplus Bio",
  tagline: "Elevate Your Aesthetics. Trust in Science.",
  email: "info@exoplusbio.com",
};

// YouTube product film: plays in the "Watch the film" modal.
export const YOUTUBE_VIDEO_ID = "Ia9Ja0oNjTI";
// It's a YouTube Short (vertical 9:16), so the modal plays it portrait.
export const YOUTUBE_IS_SHORT = true;
export const YOUTUBE_CHANNEL = "https://www.youtube.com/@ExoplusBio";

export const SOCIALS = [
  { id: "youtube", label: "YouTube", href: "https://www.youtube.com/@ExoplusBio" },
  { id: "instagram", label: "Instagram", href: "https://www.instagram.com/exoplusbio.canada/" },
  { id: "threads", label: "Threads", href: "https://www.threads.com/@exoplusbio.canada" },
  { id: "facebook", label: "Facebook", href: "https://www.facebook.com/profile.php?id=61595561202763&sk=about" },
  { id: "tiktok", label: "TikTok", href: "https://www.tiktok.com/@exoplusbio" },
];

export const IMAGES = {
  hero: "/hero-beaker-fig01.png",
  science:
    "https://static.prod-images.emergentagent.com/jobs/d9395668-0ef1-4603-8e5d-c87e1aba7878/images/54e96931018ff36aba86cfb595b861647d4967268096f6209ce753254e6808e1.jpeg",
};

export const TEAM = [
  { name: "Jeffrey Chen", role: "Chief Executive Officer" },
  { name: "Jennifer Chen", role: "Chief Business Officer" },
  { name: "Angus Liu", role: "Sales, Marketing & Social Media Director" },
  { name: "Fergus Tai", role: "Certification and QC Compliance Director" },
  { name: "Dr. Andrew Mai, MD", role: "Senior Scientific Advisor" },
  { name: "Angela Yang", role: "Administration and Operations" },
];

export const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "fr", label: "Français" },
  { code: "es", label: "Español" },
  { code: "zh-CN", label: "中文 (简体)" },
  { code: "zh-TW", label: "中文 (繁體)" },
  { code: "ko", label: "한국어" },
  { code: "vi", label: "Tiếng Việt" },
  { code: "pt", label: "Português" },
  { code: "ar", label: "العربية" },
];

export const MARQUEE_ITEMS = [
  "Exosome signaling",
  "PDRN",
  "UC-MSC",
  "Plant-derived vesicles",
  "Egg-white EVs",
  "CNF notified — Health Canada",
  "Clinical-grade cosmetic science",
  "Nano-scale delivery",
];

export const COMPLIANCE =
  "Exoplus Bio products are compliant with the Cosmetic Regulations under the Food and Drugs Act of Canada. All products distributed by Exoplus Bio in Canada have been duly notified to Health Canada via the Cosmetic Notification Form (CNF) process. These products are intended for topical, cosmetic use only to enhance skin appearance and are not Health Canada-approved 'Drugs' or 'Natural Health Products' (NHP) with therapeutic claims, unless explicitly stated otherwise with a valid DIN or NPN. Exoplus Bio makes no claims regarding the permanent alteration of body functions.";
